<template>
  <section class="skuSp-manage">
    <Card>
      <Form ref="searchForm" :model="searchForm" inline :label-width="0">
        <Row>
          <Col span="16">
            <FormItem prop="categoryCode">
              <Select
                filterable
                v-model="searchForm.categoryCode"
                placeholder="请选择分类"
                style="width: 130px"
              >
                <Option
                  :key="index"
                  :value="item.code"
                  v-for="(item, index) in categoryAllList"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>

            <FormItem prop="brandCode">
              <Select
                filterable
                v-model="searchForm.brandCode"
                placeholder="请选择品牌"
                style="width: 130px"
              >
                <Option
                  :key="index"
                  :value="item.code"
                  v-for="(item, index) in brandAllList"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem prop="skuName">
              <Input
                v-model="searchForm.skuName"
                placeholder="请输入名称"
                style="width: 300px"
              ></Input>
            </FormItem>
            <FormItem style="margin-left: 15px" class="br">
              <Button
                @click="handleSearch"
                type="primary"
                icon="ios-search"
                v-access="'skuSpManage.query'"
                >搜索</Button
              >
              <Button
                @click="handleReset"
                style="margin-left: 10px"
                v-access="'skuSpManage.reset'"
                >重置</Button
              >
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem style="margin-left: 15px" class="br">
              <Button
                @click="handleAdd"
                type="error"
                style="margin-left: 10px"
                v-access="'skuSpManage.add'"
                ><Icon type="md-add" />添加商品</Button
              >
            </FormItem>
          </Col>
        </Row>
      </Form>

      <Table
        :loading="loading"
        border
        :columns="columns"
        :data="dataSource"
        ref="table"
      ></Table>

      <Row type="flex" justify="end" class="page" style="margin-top: 10px">
        <Page
          :current="searchForm.page"
          :total="total"
          :page-size="searchForm.pageSize"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          :page-size-opts="[10, 20, 50]"
          size="small"
          show-total
          show-elevator
          show-sizer
        >
        </Page>
      </Row>
    </Card>
  </section>
</template>

<script>
export default {
  name: "skuSpManage",
  data() {
    return {
      total: 0,
      drop: false,
      loading: false,
      dataSource: [],
      brandAllList: [],
      categoryAllList: [],
      baseRetailerTypeList: [],
      statusList: [
        { label: "已发布", value: "01" },
        { label: "已上架", value: "02" },
        { label: "已下架", value: "03" },
        { label: "停用", value: "04" },
      ],
      searchForm: {
        page: 1,
        pageSize: 10,
        brandCode: "",
        categoryCode: "",
        skuName: "",
      },
      columns: [
        {
          title: "商品编码",
          key: "skuCode",
          minWidth: 80,
          align: "center",
        },
        {
          title: "名称",
          key: "erpCode",
          minWidth: 160,
        },
        {
          title: "品牌",
          key: "brandName",
          minWidth: 100,
        },
        {
          title: "分类",
          key: "categoryName",
          minWidth: 100,
        },
        {
          title: "添加人",
          key: "addOptUser",
          minWidth: 100,
        },
        {
          title: "状态",
          key: "status",
          minWidth: 100,
          render: (h, params) => {
            const { row } = params;
            const status = row.status == "1" ? true : false;
            return h(
              "i-switch",
              {
                directives: [{ name: "access", value: "skuSpManage.status" }],
                props: {
                  type: "primary",
                  value: !status,
                  beforeChange: () => this.hanldeSwitch(status, row),
                },
              },
              "编辑"
            );
          },
        },
        {
          title: "操作",
          key: "retCode",
          minWidth: 100,
          align: "center",
          fixed: "right",
          render: (h, params) => {
            const { row } = params;
            return h("div", [
              h(
                "a",
                {
                  directives: [{ name: "access", value: "skuSpManage.edit" }],
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => this.handleOpenEdit(row.id),
                  },
                },
                "编辑"
              ),
            ]);
          },
        },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getBrandAll();
      this.getCategoryAll();
      this.getSkuSpQueryList(this.searchForm);
    },
    async getBrandAll() {
      const { data } = await this.$api["brandAll"]({});
      this.brandAllList = data;
    },
    async getCategoryAll() {
      const { data } = await this.$api["categoryAll"]({});
      this.categoryAllList = data;
    },
    async getSkuSpQueryList(params = {}) {
      const { data, total } = await this.$api["skuSpQueryList"](params);
      this.dataSource = data;
      this.total = total;
    },
    handleSearch() {
      this.searchForm.page = 1;
      this.searchForm.pageSize = 10;

      const params = {
        ...this.searchForm,
      };
      this.getSkuSpQueryList(params);
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.page = 1;
      this.searchForm.pageSize = 10;

      this.searchForm.brandCode = "";
      this.searchForm.categoryCode = "";
      this.searchForm.skuName = "";
      this.getSkuSpQueryList();
    },
    handleAdd() {
      this.$router.push({
        path: "skuSpEdit",
      });
    },
    async hanldeSwitch(status, row = "") {
      return new Promise(async (resolve, reject) => {
        try {
          const params = {
            id: row.id,
          };

          const { data, code } = status
            ? await this.$api["skuSpEnable"](params)
            : await this.$api["skuSpDisable"](params);
          if (code == "200") {
            this.$Message.success("状态修改成功");
            this.getSkuSpQueryList();
            resolve();
          }
        } catch (err) {
          this.$Message.error("状态修改失败");
          reject();
        }
      });
    },
    handleOpenEdit(v) {
      this.$router.push({
        path: "skuSpEdit",
        query: {
          id: v,
        },
      });
    },
    handleOpenDeatil(v) {
      this.$router.push({
        path: "/skuInfo/detail",
        query: {
          code: v,
        },
      });
    },
    changePage(v) {
      this.searchForm.page = v;
      this.getSkuSpQueryList(this.searchForm);
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getSkuSpQueryList(this.searchForm);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/commodity/skuSpManage.vue